<template>
  <div class="action-button" @click="handleClick">
    <a-icon width="24" height="24" icon="fluent:chat-28-regular" />
  </div>
  <!-- <a-badge :count="5">

  </a-badge> -->
</template>

<script>

export default {
  components: {
  },
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'chats' }).catch(() => {})
    }
  }
}
</script>
